import React from "react";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  Glyphicon,
  ButtonToolbar
} from "react-bootstrap";
import { PropTypes } from "prop-types";
import Text from "react-format-text";
import TextareaAutosize from "react-autosize-textarea";

class EditableTextarea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: this.props.text || "",
      editing: false
    };

    this.setEditingState = this.setEditingState.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.startEdition = this.startEdition.bind(this);
    this.stopEdition = this.stopEdition.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.showLabel = this.showLabel.bind(this);
    this.checkKey = this.checkKey.bind(this);
  }

  render() {
    return (
      <div className={"editable-textarea"} id={this.props.globalContainerId}>
        <FormGroup validationState={this.validateText()}>
          {this.renderLabel()}
          {this.renderText()}
        </FormGroup>
        {this.props.hiddenButtons ? null : this.renderEditionButtons()}
      </div>
    );
  }

  renderLabel() {
    if (this.showLabel()) {
      let label = (
        <ControlLabel>
          <h4 className={"bold " + this.props.labelClassName}>
            {this.props.label}
          </h4>
        </ControlLabel>
      );
      return (
        <div>
          {label}
          {this.renderEditButton()}
        </div>
      );
    }
  }

  renderEditButton() {
    /*if( this.props.canEdit && !this.state.editing){
      return <span className="clickable btn-transparent">&nbsp;<Glyphicon glyph="pencil" onClick={this.startEdition}/></span>;  
    }
    */
    return null;
  }

  renderText() {
    let element;
    //if( this.state.editing ){
    element = (
      <FormGroup validationState={this.validateLength()}>
        <TextareaAutosize
          disabled={this.props.disabled}
          className="form-control"
          placeholder={this.props.textPlaceholder || ""}
          value={this.state.text}
          rows={this.props.rows || 4}
          onChange={this.handleTextChange}
          onBlur={this.handleSubmit}
          onKeyDown={this.checkKey}
          ref={element => (this.textAreaComponent = element)}
        />
      </FormGroup>
    );
    /*
    }
    else{
      element = (<div id={this.props.textContainerId}>{!this.showLabel() && this.renderEditButton()}&nbsp;<Text>{this.state.text}</Text></div>);
    }*/
    return element;
  }

  showLabel() {
    return this.props.showLabel == true || this.props.showLabel == null;
  }

  validateLength() {
    if (this.props.maxLength) {
      if (this.state.text.length > this.props.maxLength) {
        return "error";
      }
      return "success";
    }
    return null;
  }

  submitDisabled() {
    return this.validateLength() == "error";
  }

  renderEditionButtons() {
    let element = "";
    if (this.state.editing) {
      element = (
        <div className="text-right">
          <ButtonToolbar>
            <Button
              bsStyle="primary"
              onClick={this.handleSubmit}
              disabled={this.submitDisabled()}
            >
              {this.props.saveButtonLabel}
            </Button>
            <Button
              bsStyle="default"
              onClick={this.handleCancel}
              disabled={!this.props.text}
            >
              {this.props.cancelButtonLabel}
            </Button>
          </ButtonToolbar>
        </div>
      );
    }
    return element;
  }

  checkKey(e) {
    const { value } = this.props;
    if (e.key === "Enter" && !e.shiftKey) {
      this.preventPropagation(e);
      // this will trigger onBlur's finishEdit() method
      this.textAreaComponent.textarea.blur();
    }
  }

  startEdition() {
    if (this.props.canEdit) {
      this.setState({
        editing: true
      });
    }
  }

  stopEdition() {
    this.setState({
      editing: false
    });
  }

  handleTextChange(e) {
    this.setState({
      text: e.target.value
    });
  }

  validateText() {
    const { isInvalid } = this.props;
    if (isInvalid) {
      return isInvalid(this.state.text) ? "error" : null;
    }
  }

  handleSubmit() {
    const { isInvalid } = this.props;
    if (this.state.text) {
      if (!(isInvalid && isInvalid(this.state.text))) {
        this.props.onSubmit(this.state.text);
        this.stopEdition();
      }
    }
  }

  handleCancel() {
    this.setState({
      text: this.props.text || ""
    });
    if (this.props.text) {
      this.stopEdition();
    }
  }

  componentWillMount() {
    this.setEditingState();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      text: nextProps.text,
      editing: nextProps.text == "" && this.props.canEdit
    });
  }

  setEditingState() {
    const editing = this.state.text == "" && this.props.canEdit;
    this.setState({
      editing: editing
    });
  }
}

EditableTextarea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  text: PropTypes.string,
  textContainerId: PropTypes.string,
  textPlaceholder: PropTypes.string,
  saveButtonLabel: PropTypes.string,
  globalContainerId: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  canEdit: PropTypes.bool,
  showLabel: PropTypes.bool,
  labelClassName: PropTypes.string,
  rows: PropTypes.number
};

export default EditableTextarea;
